<nav class="nav-str">
  <span *ngFor="let item of naviString; let i = index">
    <a [routerLink]="item.link" [queryParams]="item.params" [fragment]="item.fragment" >{{item.text}}</a> 
    {{i < (naviString.length - 1) ? ">" : ""}} 
  </span>
</nav>
